"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cardDeliveryMethodEnumArray = exports.CardDeliveryMethodEnum = void 0;
var CardDeliveryMethodEnum;
(function (CardDeliveryMethodEnum) {
    CardDeliveryMethodEnum["STANDARD_DELIVERY"] = "STANDARD_DELIVERY";
    CardDeliveryMethodEnum["REGISTERED_MAIL"] = "REGISTERED_MAIL";
    CardDeliveryMethodEnum["COURIER"] = "COURIER";
    CardDeliveryMethodEnum["FIRST_CLASS_MAIL"] = "FIRST_CLASS_MAIL";
})(CardDeliveryMethodEnum || (exports.CardDeliveryMethodEnum = CardDeliveryMethodEnum = {}));
exports.cardDeliveryMethodEnumArray = Object.values(CardDeliveryMethodEnum);
